export default __webpack_public_path__ + "static/media/1849.119ef4cf.png";